import { CASINO_IMGIX, CDN_URL } from "../cdn";

const bitcasino: SiteConfig = {
  name: "Bitcasino",
  handle: "bitcasino",
  defaultLang: "en",
  csEmail: "cs@bitcasino.io",
  languages: [
    "en",
    "ja",
    "pt",
    "zh",
    "es",
    "ko",
    "th",
    "de",
    "fr",
    "vi",
    "tr",
    "ar",
    "id",
  ],
  domain: "bitcasino.io",
  refCode: "bcseo",
  isBridgeSite: false,
  fontTypes: ["Space Grotesk", "DM Sans"],
  iconSetCdnPath: `${CDN_URL}/luxury/icons`,
  iconSetExt: ".png",
  defaultColorScheme: "light",
  blogCategories: [
    "slots",
    "live-dealer",
    "tipshackstricks",
    "promotions",
    "vip",
    "cryptocurrency",
    "loyalty",
    "esports",
  ],
  privacyPolicyLink:
    "/help-center/help-terms-and-conditions/bitcasino-privacy-policy",
  termsAndConditionsLink:
    "/help-center/help-terms-and-conditions/bitcasino-terms-and-conditions-of-use-of-services-of-the-company",
  registerButtonText: "profile.create_account",
  fullstoryAccountId: "BSWGQ",
  optimoveConfig: {
    tenantId: 2065,
  },
  menuItemsConfig: {
    common: {
      first: 5,
      filterName: "^(?!(live|bombay).*$)",
    },
    live: {
      first: 5,
      filterName: "^live",
    },
  },
  protoConfig: {
    gwId: "gw_hWGneEJutXAqZOvHpaP7dx",
  },
  isLoggedOutLiveChatEnabled: true,
  convertComConfig: {
    isScriptEnabled: true,
    url: "https://cdn-4.convertexperiments.com/v1/js/100414391-10048780.js",
  },
  icons: {
    icon: [
      {
        url: `https://${CASINO_IMGIX}/bitcasino/favicon/bc-32x32.png`,
        sizes: "32x32",
        type: "image/png",
      },
      {
        url: `https://${CASINO_IMGIX}/bitcasino/favicon/bc-16x16.png`,
        sizes: "16x16",
        type: "image/png",
      },
    ],
    apple: [
      {
        sizes: "180x180",
        url: `https://${CASINO_IMGIX}/bitcasino/favicon/bc-180x180.png`,
      },
    ],
    other: [
      {
        rel: "mask-icon",
        url: `https://${CASINO_IMGIX}/bitcasino/favicon/safari-pinned-tab.svg`,
        color: "#F2590D",
      },
    ],
  },
  themeColor: "#F2590D",
  seo: {
    title: "general.title",
    description: "general.meta_description",
    og: {
      title: "og.title",
      description: "og.description",
      image: `https://${CASINO_IMGIX}/bitcasino/images/logo-bitcasino-orange.jpg`,
    },
  },
  bcioSiteId: "3",
  featurebaseOrganization: "bitcasino",
};

export default bitcasino;
